import React, { useContext, useEffect, useState } from "react"
import "./style.scss"
import { Link } from "react-router-dom"
import logo from "../../../../assets/users/transparent.png"
import { Button } from "@mui/material";
import { FaAngleRight, FaCartPlus, FaUserPlus } from "react-icons/fa";
import { FaBookBookmark, FaClipboardUser } from "react-icons/fa6";
import { GrUserAdmin } from "react-icons/gr";
import { RiDashboardHorizontalFill } from "react-icons/ri";
import { GiRoundStar } from "react-icons/gi";
import { MdCampaign, MdFormatListBulletedAdd } from "react-icons/md";
import { TbBrandCashapp } from "react-icons/tb";
import { PiDiamondThin } from "react-icons/pi";
import { MyContext } from "../adminLayout";
import { introspective } from "services/tokenService";
import { IoIosStar } from "react-icons/io";
const Sidebar = () => {
    const context = useContext(MyContext)
    const [role, setRole] = useState(""); 
    const token = localStorage.getItem('token');

    const [activeTabs, setActiveTabs] = useState(() => {
        // Lấy giá trị từ localStorage hoặc dùng giá trị mặc định là 0 nếu không có
        return parseInt(localStorage.getItem('activeTab'), 10) || 0;
    });
    const [isToggleSubmenu, setIsToggleSubmenu] = useState(true);

    const isOpenSubmenu = (index) => {
        if (activeTabs === index && isToggleSubmenu) {
            setIsToggleSubmenu(false);
        } 
        else {
            setActiveTabs(index);
            setIsToggleSubmenu(true);
            localStorage.setItem('activeTab', index);
        }
    };
        
    useEffect(() => {
        const fetchRole = async () => {
            try {
                const response = await introspective(token);
                if (response.data) {
                    setRole(response.data.role)
                }
            } 
            catch (error) {
                console.log("introspective failed:", error);
            } 
        };

        fetchRole();

    }, [token]);

    return (
        <div className="sidebar1 shadow">
            <div className="logoAdmin">
                <Link to="/admin">
                    <img onClick={() => isOpenSubmenu(0)} src={logo} alt="" />
                </Link>
            </div>
            <div>
                <ul>
                    <li>
                        <Link to="/admin">
                            <Button 
                                className={`w-100 ${activeTabs===0  ? 'active' : ''}`}
                                onClick={() => isOpenSubmenu(0)}
                            >
                                <span className="icon me-3"><RiDashboardHorizontalFill/></span>
                                Dashboard
                            </Button>
                        </Link>
                    </li>

                    <li>
                        <Link to="/admin/campaign">
                            <Button 
                                className={`w-100 ${activeTabs===8  ? 'active' : ''}`}
                                onClick={() => isOpenSubmenu(8)}
                            >
                                <span className="icon me-3"><MdCampaign/></span>
                                Chiến dịch
                            </Button>
                        </Link>
                    </li>

                    <li>
                        <Button 
                            className={`w-100 ${activeTabs===1 ? 'active' : ''}`}
                            onClick={() => isOpenSubmenu(1)}
                        >
                            <span className="icon me-3"><FaBookBookmark/></span>
                            Quản lí sách
                            <span className="arrow ms-auto"><FaAngleRight/></span>
                        </Button>

                        <div className={`submenuWrapper ${activeTabs===1 &&isToggleSubmenu===true ? 'openSubmenu' : 'closeSubmenu'}`}>
                            <ul className="submenu1">
                                <li className="mb-1 d-flex">
                                    <PiDiamondThin />
                                    <Link to="/admin/list-book/all">Kho sách</Link>
                                </li>
                                <li className="mb-1 d-flex">
                                    <PiDiamondThin />
                                    <Link to="/admin/add-book">Thêm mới sách</Link>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li>
                        <Link to="/admin/list-category">
                            <Button 
                                className={`w-100 ${activeTabs===2  ? 'active' : ''}`}
                                onClick={() => isOpenSubmenu(2)}
                            >
                                <span className="icon me-3"><MdFormatListBulletedAdd/></span>
                                Thể loại
                            </Button>
                        </Link>
                    </li>

                    <li>
                        <Link to="/admin/list-order/all">
                            <Button 
                                className={`w-100 ${activeTabs===4 ? 'active' : ''}`}
                                onClick={() => isOpenSubmenu(4)}
                            >
                                <span className="icon me-3"><FaCartPlus/></span>
                                Đơn hàng
                            </Button>
                        </Link>
                    </li>

                    {role === "superadmin" && (
                        <li>
                            <Link to="/admin/list-admin/all">
                                <Button 
                                    className={`w-100 ${activeTabs===9 ? 'active' : ''}`}
                                    onClick={() => isOpenSubmenu(9)}
                                >
                                    <span className="icon me-3"><GrUserAdmin/></span>
                                    Quản lí admin
                                </Button>
                            </Link>
                        </li>
                    )}

                    <li>
                        <Link to="/admin/list-customer/all">
                            <Button 
                                className={`w-100 ${activeTabs===5 ? 'active' : ''}`}
                                onClick={() => isOpenSubmenu(5)}
                            >
                                <span className="icon me-3"><FaUserPlus/></span>
                                Khách hàng
                            </Button>
                        </Link>
                    </li>

                    <li>
                        <Link to="/admin/list-review/pending">
                            <Button 
                                className={`w-100 ${activeTabs===6  ? 'active' : ''}`}
                                onClick={() => isOpenSubmenu(6)}
                            >
                                <span className="icon me-3"><IoIosStar/></span>
                                Đánh giá
                            </Button>
                        </Link>
                    </li>

                    <li>
                        <Link to="/admin/revenue-statistics">
                            <Button 
                                className={`w-100 ${activeTabs===7  ? 'active' : ''}`}
                                onClick={() => isOpenSubmenu(7)}
                            >
                                <span className="icon me-3"><TbBrandCashapp/></span>
                                Thống kê
                            </Button>
                        </Link>
                    </li>
                </ul>
            </div>
        </div>

    )
}

export default Sidebar;